<div class="select-columns">
	<button dz-button color="secondary" (click)="selectColumnsClicked($event)" dcrHTMLKey="SHOW_COLUMNS_BUTTON_LABEL">Show/Hide Columns</button>
	<div class="columns-section text-align-left" [class.inactive]="!showColumns">
		<div class="row dz-row group align align-items-center">
			<div class="col-12 dz-col-12 asset">
				<dz-checkbox [checked]="allColumnsSelected" [indeterminate]="someColumnsSelected" (change)="toggleAll()">
					<span class="text-16-bold" dcrHTMLKey="ALL_COLUMNS_LABEL">All Columns</span>
				</dz-checkbox>
			</div>
			<div class="col-12 dz-col-12 asset cursor-pointer" (click)="resetColumns()">
				<dz-icon class="margin-right-5 color-blk-orange" type="undo"> </dz-icon><span class="text-16-bold" dcrHTMLKey="RESET_COLUMNS_LABEL">Reset Columns</span>
			</div>
		</div>
		<div class="column-list">
			<div class="group" *ngFor="let group of groups">
				<div class="asset">
					<dz-checkbox
						class="d-inline-flex"
						(change)="toggleGroup(group)"
						[checked]="group.status === groupStatus.ALL"
						[indeterminate]="group.status === groupStatus.SOME"
					>
						<span class="text-16-bold" [dcrHTMLKey]="group.name + '_LABEL'">{{ group.name }}</span>
					</dz-checkbox>
				</div>
				<ng-container *ngFor="let column of columnDefsState | keyvalue : sortNull">
					<div class="columns" *ngIf="column.value.headerData.attribute['columnGroup'] === group.name && !column.value.headerData.attribute['pinned']">
						<div class="asset">
							<dz-checkbox
								class="d-inline-flex"
								(change)="toggleColumn(column.value.headerData.config.id, group)"
								[checked]="column.value.selected"
								custom-tracking
								[track-event]="'selectColumns:' + column.value.headerData.config.id + ':' + (!column.value.selected ? 'on' : 'off')"
							>
								<span>{{ column.value.headerData.formattedValue }}</span>
							</dz-checkbox>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
